<template>
  <messenger-chat
    :conversation="conversation">
  </messenger-chat>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { MessengerChat } from '@/components/messenger'
  export default {
    components: {
      MessengerChat
    },
    props: {
      _id: {
        type: String,
        required: true
      },
      scope: {
        type: String,
        default: 'user'
      },
      name: {
        type: String,
        default: ''
      },
      externalId: {
        type: Number,
        default: null
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'skiliko/session/currentUser'
      }),
      conversation () {
        return {
          to: {
            _id: this._id,
            scope: this.scope,
            externalId: this.externalId,
            name: this.name
          },
          from: {
            _id: this.currentUser.chatable_id,
            scope: 'admin',
            externalId: this.currentUser,
            name: this.currentUser.nickname
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/MessengerNew.vue